class WatcherStateForm {
    constructor(listItemId, mainElementId) {
        this.listElements = listItemId.map(item => document.querySelector(item))
        this.mainElement = document.querySelector(mainElementId)
        this.formIsValid = false
        this.mask = document.querySelector('.btnMask')
      }
    checkState() {
        let counter = 0
        this.listElements.forEach(element => {
           if(element.classList.contains('success')) counter++
        });
        if(counter === this.listElements.length) {
            this.mainElement.classList.add('success')
            this.formIsValid = true
            this.mask.classList.add('display-none')
        } else {
            this.mainElement.classList.remove('success')
            this.formIsValid = false
            this.mask.classList.remove('display-none')
        }
    }
    getFormIsValid() {
        return this.formIsValid
    }
    getIsSuccessStatusByKey(elementId) {
        return document.querySelector(elementId).classList.contains('success')
    }
}

export default WatcherStateForm